import { apiRequest } from 'utils/request'

export const get = async ({ id }) => {
  const response = await apiRequest({
    uri: `/features/${id}/revisions`,
  })

  return response
}

export const create = async ({ id, note, subType, subUri, subDescription }) => {
  const response = await apiRequest({
    uri: `/features/${id}/revisions/add`,
    method: 'POST',
    body: {
      eventType: 'notes',
      eventNotes: note,
      subType,
      subUri,
      subDescription,
    },
  })

  return response
}
